var _style, _path, _path2, _path3, _path4, _path5, _path6, _g, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgThriveLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 270.9 68.1",
    style: {
      enableBackground: "new 0 0 270.9 68.1"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0076BC;}\n\t.st1{fill:#E02827;}\n\t.st2{fill:#82BD41;}\n\t.st3{fill:#81BD41;}\n\t.st4{fill:#7DAED3;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.8,46V33.1h-6.7v-5.9h6.7V14.9l6.6,0v12.2h10.9v5.9H80.4v11.7c0,4.5,0.7,8.6,5.4,8.6c1.9,0,4-0.7,5.4-1.5 v6.2c-1.5,0.7-4,1.3-6.5,1.3c-2.7,0-5.9-0.7-8.2-3.4C74.7,54,73.8,51.1,73.8,46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M101.3,2.4h6.6V27l0.1,0.1c3.2-3.2,7.6-5.4,12.6-5.4c4,0,7.4,1.4,9.6,4c2,2.3,3,5.1,3,10.6v22.3h-6.6V37.5 c0-4-0.5-5.9-1.8-7.3c-1.4-1.6-3.2-2.3-5.5-2.3c-4.3,0-8.8,2.7-11.5,6v24.8h-6.6L101.3,2.4L101.3,2.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M144.3,22.4h6.6v5.3l0.1,0.1c2.5-3.5,6.5-5.7,10.7-5.7c0.7,0,1.5,0.1,2.4,0.3v6.5c-0.9-0.2-1.8-0.3-2.6-0.3 c-4.9,0-8.4,2.5-10.7,6.4v23.5h-6.6L144.3,22.4L144.3,22.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M173,22.4h6.6v36.1H173V22.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M187.6,22.4h7.2l6.7,16.3c1.6,4,3.1,7.6,4.6,11.6h0.1c1.6-4.1,3.2-7.9,4.9-12l6.5-15.9h6.9l-15.1,36.1h-6.6 L187.6,22.4z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M233.7,42.4c0.9,7.1,6.2,11,13.4,11c5,0,9.2-2,12.5-4.5v7c-3.2,2.1-8.2,3.4-12.9,3.4 c-11.2,0-19.5-7.5-19.5-18.9c0-11.4,8.3-18.9,18-18.9c8.8,0,16.5,6.2,16.5,17.5c0,1.1-0.1,2.4-0.2,3.3L233.7,42.4L233.7,42.4z  M233.8,37.2h21.3c-0.6-7.2-5.9-9.6-10.2-9.6C240.1,27.6,235,30.5,233.8,37.2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M18.3,11.8c8.6,1.1,11.1,7.2,11.3,7.9c0.2-0.6,2.7-6.7,11.3-7.9c2-0.3,3.9-0.2,5.8,0.3L29.6,0L12.5,12.1 C14.4,11.7,16.4,11.6,18.3,11.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M4.9,35.9v22.8h23C23.2,55.1,10.3,44.9,4.9,35.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.5,58.7h22.8V36C48.9,44.9,36.2,55.1,31.5,58.7"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M176.3,5.4c2.6,0,4.6,2.1,4.6,4.6s-2.1,4.6-4.6,4.6s-4.6-2.1-4.6-4.6S173.7,5.4,176.3,5.4"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgThriveLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/thrive-logo.69de7fa176956b79391d070c7f808893.svg";